import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  handleAdobeNavEvent,
  adobeCleanString,
} from '../../../helpers/adobe-analytics';

export class Raymond extends Lit3formBlock {
  static get characterName() {
    return 'raymond';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid raymond-layout">
          ${this.headerHTML}
          <div class="drivers">
            ${this.driversArr.map(driver => this.driversHTML(driver[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerStr
      ? html`
          <div class="header">
            <h2>${unsafeHTML(this.headerStr)}</h2>
            ${this.descriptionHTML}
          </div>
        `
      : ``;
  }

  driversHTML(driver) {
    return html`
      <span class="driver-wrapper">
        <a
          class="image"
          href=${this.imageHref(driver)}
          rel="noopener"
          @click="${event => {
            event.preventDefault();
            handleAdobeNavEvent({
              navString: `NAV|${adobeCleanString(
                this.headerStr
              )}|${adobeCleanString(driver.title || driver.text || '')}`,
              destinationUrl: driver.url,
              event,
            });
          }}"
        >
          <img src=${this.imageUrl(driver)} />
        </a>
        <h3 class="image-title">
          ${unsafeHTML(this.withLineBreaks(driver.title))}
        </h3>
        <p class="image-description">
          ${unsafeHTML(this.withLineBreaks(driver.description))}
        </p>
      </span>
    `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, 400);
  }

  get driversArr() {
    return !this.content.images || this.content.images.length === 0
      ? []
      : this.content.images;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }
}
Raymond.defineElement();
